// extracted by mini-css-extract-plugin
export default {"priceMarker":"priceMarker_G+4WK"};